<template>
  <ets-popup title="Errores" v-if="display" @close="closePopup()" hideFooter>
    <ets-alert v-if="errors.length !== 0" type="error">
      <ul>
        <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
      </ul>
    </ets-alert>
  </ets-popup>
</template>

<script>
export default {
  name: "PopupErrors",
  props: {
    displayErrors: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    display: false
  }),
  methods: {
    closePopup() {
      this.display = false;
      this.$emit("display-errors", this.display);
    }
  },
  watch: {
    displayErrors: {
      immediate: true,
      handler() {
        this.display = this.displayErrors;
      }
    }
  }
};
</script>
